// extracted by mini-css-extract-plugin
module.exports = {"rating":"_3ulNI3","star":"_1FmJZJ","star__icon":"_2kLvkg","on":"cYMf5Z","hover":"_1mtIRw","active":"_10mBeP"};